import React, { useRef, useState, Suspense, useEffect, useLayoutEffect } from "react";
import "./Components/Styles/App.css";
import { UI } from "./UI";
import SelectionWindow from "./Components/Selections/SelectionWindow";
import {
  ExitButton,
  UnityBuildPrefix,
  ZoomEventTarget,
  controlsState,
  hideDialogue,
} from "./helpers";
import MakeUpStation from "./Components/Selections/MakeUpStation";
import HairStation from "./Components/Selections/HairStation";
import Dialogue from "./Components/Dialogue";
import { Unity, useUnityContext } from "react-unity-webgl";
import EndScreen from "./Components/Selections/EndScreen";

import FrontPage from "./frontPage/Front.jsx";
import InfoScreen from "./Components/Selections/InfoScreen";

/**
 * @typedef {import("./Components/Selections/Endscreen.d.ts").EndScreenProps} EndScreenProps
 * @typedef {import("./Components/Selections/Endscreen.d.ts").VaatteetOptions} VaatteetOptions
 * @typedef {import("./Components/Selections/Endscreen.d.ts").LahjaOptions} LahjaOptions
 */

/**
 * Ylätason näkymä
 *
 * @param {object} props - The component props.
 * @param {HTMLElement} props.container - The HTML element to mount the component to.
 * @return {JSX.Element} The rendered component.
 */

/**
 * Lahjan laatu
 * @enum {string}
 */

const LahjaLaatu = {
  hyva: "ok",
  huono: "huono",
  puuttuu: "puuttuu"
}

/**
 * The available game events.
 * @enum {string}
 */
const GameEvents = {
  TOGGLE_WARDROBE: "toggleWardrobe",
  TOGGLE_MAKEUP: "toggleMakeup",
  TOGGLE_HAIR: "toggleHair",
  DIALOGUE_MESSAGE: "dialogueMessage",
  PRESENT_SELECTED: "presentSelected",
  END_SCREEN: "endScreen",
  INFO_SCREEN: "infoScreen",
  HIDE_DIALOGUE: "hideDialogue"
};
function App({ container, parameters }) {
  const [showWardrobe, setShowWardrobe] = useState(false);
  const [showMakeUpStation, setShowMakeUpStation] = useState(false);
  const [showHairStation, setShowHairStation] = useState(false);
  const [showEndScreen, setShowEndScreen] = useState(false);
  const[showInfoScreen, setShowInfoScreen] = useState(false);
  const [loadUnity, setLoadUnity] = useState(false);
  const [lahjanLaatu, setLahjanLaatu] = useState(LahjaLaatu.puuttuu);


  const [selectedClothes, setSelectedClothes] = useState(["", ""]);
  const [selectedMakeup, setSelectedMakeup] = useState(["", ""]);
  const [selectedHair, setSelectedHair] = useState(["", ""]);
  const [dialogueText, setDialogueText] = useState("");


  /**
 * @typedef {boolean|null} LahjaValue
 */

/**
 * @type {React.MutableRefObject<LahjaValue>}
 */
  const lahja = useRef(null);

  const storeClothes = (upper, lower) => {
    setSelectedClothes([upper[0].id, lower[0].id]);
  };

  useEffect(() => {
    console.log(selectedMakeup)
  }, [selectedMakeup]);
  /**
   * @type {React.RefObject<HTMLElement>}
   */
  const canvasRef = useRef(null);

  const [controlsEnabled, setControlsEnabled] = useState(true);

  const buildPrefix = UnityBuildPrefix(parameters.buildName);
  const {
    unityProvider,
    loadingProgression,
    isLoaded,
    requestPointerLock,
    sendMessage,
    addEventListener,
    removeEventListener,
  } = useUnityContext({
    loaderUrl: buildPrefix + "/Build.loader.js",
    dataUrl: buildPrefix + "/Build.data.gz",
    frameworkUrl: buildPrefix + "/Build.framework.js.gz",
    codeUrl: buildPrefix + "/Build.wasm.gz",
  });

  const pauseGame = () => {
    return null; //katsotaan tarvitaanko pausettamista ollenkaan
    sendMessage("MessagesFromReact", "PauseGame");
  };

  const resumeGame = () => {
    return null; //katsotaan tarvitaanko pausettamista ollenkaan
    sendMessage("MessagesFromReact", "ResumeGame");
  };

  const toggleWardRobe = () => {
    pauseGame();
    setShowWardrobe((prevState) => !prevState);
  
  };

  const toggleMakeUp = (str) => {
    pauseGame();
    setShowMakeUpStation((prevState) => !prevState);
  };

  const toggleHair = () => {
    pauseGame();
    setShowHairStation((prevState) => !prevState);
  };

  const showDialogue = (msg) => {
    console.log({ msg });
    setDialogueText(msg);
  };

  const storePresent = (present) => {
    // Tästä eteenpäin rakennetaan kaikki lahjaan liittyvä logiikka
    if(present === "pehmolelu") {
      setLahjanLaatu(LahjaLaatu.huono);
      console.log("pehomolelu lahja");
    } else {
      setLahjanLaatu(LahjaLaatu.hyva);
      console.log("muu lahja");
    }
  };

  const endingScreen = () => {
    hideDialogue();
    setShowEndScreen(true)
  }

  const revealInfoScreen = () => {
    hideDialogue();
    setShowInfoScreen(true);
  }

  useEffect(() => {
    sendMessage("MessagesFromReact", "VaatteetHoidettu");
    resumeGame();
  }, [selectedClothes]);

  useEffect(() => {
    sendMessage("MessagesFromReact", "MeikitHoidettu");
    resumeGame();
  }, [selectedMakeup]);

  useEffect(() => {
    console.log({ selectedHair });
    sendMessage("MessagesFromReact", "HiuksetHoidettu");
    resumeGame();
  }, [selectedHair]);


  const hideYleHeaders = () => {
    const eventName = "hideheaders";
    const message = JSON.stringify({
      message: eventName,
      date: Date.now(),
    });
    if (window.parent) {
      window.parent.postMessage(message, "*");
    }
  }

  useEffect(() => {
    
    console.log("isload" + isLoaded);
    if (!isLoaded) return;
    addEventListener(GameEvents.TOGGLE_MAKEUP, toggleMakeUp);
    addEventListener(GameEvents.TOGGLE_WARDROBE, toggleWardRobe);
    addEventListener(GameEvents.TOGGLE_HAIR, toggleHair);
    addEventListener(GameEvents.DIALOGUE_MESSAGE, showDialogue);
    addEventListener(GameEvents.PRESENT_SELECTED, storePresent);
    addEventListener(GameEvents.END_SCREEN, endingScreen);
    addEventListener(GameEvents.INFO_SCREEN, revealInfoScreen);
    addEventListener(GameEvents.HIDE_DIALOGUE, hideDialogue);
    window.logGlobalVariables = () => {
      sendMessage("MessagesFromReact", "LogVariables");
    };

    return () => {
      removeEventListener(GameEvents.TOGGLE_MAKEUP, toggleMakeUp);
      removeEventListener(GameEvents.TOGGLE_WARDROBE, toggleWardRobe);
      removeEventListener(GameEvents.TOGGLE_HAIR, toggleHair);
      removeEventListener(GameEvents.DIALOGUE_MESSAGE, showDialogue);
      removeEventListener(GameEvents.PRESENT_SELECTED, storePresent);
      removeEventListener(GameEvents.END_SCREEN, endingScreen);
      removeEventListener(GameEvents.INFO_SCREEN, revealInfoScreen);
      removeEventListener(GameEvents.HIDE_DIALOGUE, hideDialogue);
      container.removeEventListener("test", toggleMakeUp);
    };
  }, [isLoaded]);

  useLayoutEffect( () => {
    if(isLoaded) {
      window.scroll({top:0})
    }
  }, [isLoaded])


  /**
   * Generates the end screen props.
   *
   * @return {EndScreenProps} The end screen props.
   */
  const generateEndScreenProps = () => {
    /**
     * @type {VaatteetOptions}
     */
    let vaatteet = "huono";
    if (selectedClothes[0] != "" && selectedClothes[0] === selectedClothes[1]) {
      vaatteet = "onnistunut";
    } else if (
      (selectedClothes[0] === "B" && selectedClothes[1] === "C") ||
      (selectedClothes[0] === "A" && selectedClothes[1] === "C") ||
      (selectedClothes[0] === "C" && selectedClothes[1] === "B")
    ) {
      vaatteet = "ok";
    } else {
      vaatteet = "huono";
    }

    /**
     * @type {LahjaOptions}
     */
    let lahjateksti = "puuttuu";

    if(lahjanLaatu === LahjaLaatu.hyva) {
      lahjateksti = "ok"
    } else if (lahjanLaatu === LahjaLaatu.huono) {
      lahjateksti = "huono"
    } else if(lahjanLaatu === LahjaLaatu.puuttuu) {
      lahjateksti = "puuttuu"
    }

    return {
      lahja: lahjateksti,
      vaatteet,
      huulikiilto: selectedMakeup[1] === "huulikiilto"
    };
  };

  const aloitaButtonPress = () => {
    const eventName = "hideheaders";
    const message = JSON.stringify({
      message: eventName,
      date: Date.now(),
    });
    if (window.parent) {
      window.parent.postMessage(message, "*");
    }

    //window.scroll({top: 0, behavior: "smooth"})
    setLoadUnity(true);
  }

  return (
    <>
      {!isLoaded && <FrontPage loadUnity={loadUnity} aloitaButtonPress={aloitaButtonPress} progress={Math.round(loadingProgression * 100)}/>}
      {/**tässä on dialogi, mitä voi käyttää kaikkialla nyt, käytä setDialogueText muuttaaksesi dialogia */}
      <Dialogue setDialogue={setDialogueText} dialogue={dialogueText} />
      <div id="container" style={{height: isLoaded || showEndScreen || showInfoScreen ? "100vh" : "0vh"}} >
        <UI />

        <SelectionWindow
          visible={showWardrobe}
          chosenItems={storeClothes}
          setVisibility={setShowWardrobe}
          dialogue={dialogueText}
          setDialogue={setDialogueText}
        />
        <MakeUpStation
          visible={showMakeUpStation}
          dialogue={dialogueText}
          setDialogue={setDialogueText}
          setSelectedMakeup={setSelectedMakeup}
          selectedMakeup={selectedMakeup}
          setVisibility={setShowMakeUpStation}
        />
        <HairStation
          visible={showHairStation}
          dialogue={dialogueText}
          setDialogue={setDialogueText}
          setVisibility={setShowHairStation}
          setSelectedHair={setSelectedHair}
          selectedHair={selectedHair}
        />
        <InfoScreen visible={showInfoScreen} close={() => setShowInfoScreen(false)} />
        <EndScreen visible={showEndScreen} {...generateEndScreenProps()}></EndScreen>
        <>
          {loadUnity && (
            <Unity 
              unityProvider={unityProvider}
              style={{
                visibility: isLoaded ? "visible" : "hidden",
                width: "100%",
                height: "100%",
              }}
            />
          )}
        </>
      </div>
    </>
  );
}
export default App;
